import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-white/30 rounded-[2rem] my-12" data-id="element-171">
      <div className="text-center mb-16" data-id="element-172">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6 max-w-3xl mx-auto" data-id="element-173">
          Presentamos la Guía que tu médico debería haberte dado desde el
          principio
        </h2>
        <h3 className="text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-174">
          💊 GUÍA COMPLETA DE ANTICONCEPTIVOS ORALES
        </h3>
      </div>

      <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex-1 relative w-full max-w-md lg:max-w-full" data-id="element-176">
          <div className="relative rounded-[2rem] border-8 border-white shadow-2xl overflow-hidden bg-white aspect-[4/5] mx-auto max-w-sm transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/uY8uqDzj7yHUkewnswcYgi/portada_anticonceptivos.png" alt="Guía Completa de Anticonceptivos Orales" className="w-full h-full object-cover" data-id="element-178" />
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-white/30 pointer-events-none" data-id="element-179"></div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex-1" data-id="element-180">
          <div className="bg-white p-8 md:p-10 rounded-[16px] shadow-lg border border-brand-cardPurple/50" data-id="element-181">
            <p className="text-lg md:text-xl text-brand-dark leading-relaxed" data-id="element-182">
              Una guía de{' '}
              <span className="font-bold text-brand-primary" data-id="element-183">45+ páginas</span>{' '}
              diseñada para que cualquier mujer entienda exactamente cómo
              funcionan los anticonceptivos orales, cómo tomarlos correctamente
              y qué hacer en cada situación.
            </p>
            <div className="mt-6 space-y-4" data-id="element-184">
              <p className="text-lg text-brand-secondary flex items-center gap-3" data-id="element-185">
                <span className="text-brand-accent" data-id="element-186">✓</span> Sin lenguaje médico
                complicado.
              </p>
              <p className="text-lg text-brand-secondary flex items-center gap-3" data-id="element-187">
                <span className="text-brand-accent" data-id="element-188">✓</span> Sin tabúes.
              </p>
              <p className="text-lg text-brand-secondary flex items-center gap-3" data-id="element-189">
                <span className="text-brand-accent" data-id="element-190">✓</span> Con toda la
                información que necesitas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}